module.exports = __webpack_public_path__ + "media/components/images/panels/4-b-7dcdab8f9fcf902eb78ad92b98a15c3a.jpeg";